export const toIsoDateTime = (value) => {
    if (!value) return new Date().toISOString();
    const parsed = new Date(value.replace(" ", "T"));
    return isNaN(parsed.getTime()) ? new Date().toISOString() : parsed.toISOString();
  };


  export const formatDateTime = (value) => {
    if (!value) return "N/A";
    const parsed = new Date(String(value).replace(" ", "T"));
    return isNaN(parsed.getTime())
      ? value
      : parsed.toLocaleString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
  };